<div class="card mb-3">
  <div class="card-header">
    <fa-icon [icon]="['fas', 'magnifying-glass']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
    {{ 'norge.soknad.velg-sak-tittel' | translate }}
  </div>
  <div class="card-body">
    @if (selectedCase) {
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
        <div>
          <div class="search-text-label">{{ 'norge.soknad.valgt-sak' | translate }}</div>
          <div class="selected-case-name">{{ selectedCase.companyName }} ({{ selectedCase.orgNr }})</div>
        </div>
        <button class="btn-garanti btn-blue" type="button" (click)="changeCase()">{{ 'norge.soknad.endre' | translate }}</button>
      </div>
    } @else {
      <p class="search-text-label mb-4">
        {{ 'norge.soknad.velg-sak-hint' | translate }}
      </p>

      <form [formGroup]="form" (ngSubmit)="search()">
        <div class="row g-2 align-items-start">
          <div class="col-12 col-lg-10 mb-0">
            <label class="label-search" for="searchQuery">{{ 'norge.soknad.sok-etikett' | translate }}</label>
            <input id="searchQuery" type="text" class="form-control" formControlName="searchQuery"
              autocomplete="off" [placeholder]="'norge.soknad.sok-plassholder' | translate" />

            <div class="validation-space">
              <small class="text-danger ms-2"
                [class.invisible]="!(searchQueryField?.touched && searchQueryField?.invalid)">
                {{ 'norge.soknad.sok-validering' | translate }}
              </small>
            </div>
          </div>

          <div class="col-12 col-lg-2 mb-0">
            <label class="label-search invisible">{{ 'norge.soknad.sok-knapp' | translate }}</label>

            <button class="btn-garanti btn-blue w-100 search-button" type="submit" [disabled]="isSearching || form.invalid">
              @if (!isSearching) {
                <span>{{ 'norge.soknad.sok-knapp' | translate }}</span>
              }
              @if (isSearching) {
                <span>{{ 'norge.soknad.soker' | translate }}</span>
              }
            </button>

            <div class="validation-space"></div>
          </div>
        </div>

        @if (showResults && searchResults.length === 0) {
          <div class="mt-2 text-muted">
            {{ 'norge.soknad.ingen-treff' | translate }}
          </div>
        }

        @if (searched && isSearching) {
          <div class="mt-4">
            @for (i of skeletonRows; track i) {
              <div class="search-skeleton-row">
                <div class="skeleton skeleton-name"></div>
                <div class="skeleton skeleton-orgnr"></div>
                <div class="skeleton skeleton-date"></div>
              </div>
            }
          </div>
        }

        @if (showResults && searchResults.length > 0) {
          <div class="mt-3 table-responsive">
            <table class="table table-hover search-results-table mb-0">
              <thead>
                <tr>
                  <th>{{ 'norge.soknad.kolonne-selskap' | translate }}</th>
                  <th class="text-nowrap col-orgnr">{{ 'norge.soknad.kolonne-orgnr' | translate }}</th>
                  <th class="text-nowrap col-date">{{ 'norge.soknad.kolonne-konkursapning' | translate }}</th>
                  <th class="text-nowrap col-trustee">{{ 'norge.soknad.kolonne-bostyrer' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (result of searchResults; track trackByCaseId($index, result)) {
                  <tr
                    (click)="selectCase(result)"
                    (keydown.enter)="selectCase(result)"
                    (keydown.space)="$event.preventDefault(); selectCase(result)"
                    [attr.aria-label]="result.companyName"
                    tabindex="0"
                    role="button">
                    <td class="result-name" [attr.data-name]="'norge.soknad.kolonne-selskap' | translate">{{ result.companyName }}</td>
                    <td class="text-nowrap" [attr.data-name]="'norge.soknad.kolonne-orgnr' | translate">{{ result.orgNr }}</td>
                    <td class="text-nowrap" [attr.data-name]="'norge.soknad.kolonne-konkursapning' | translate">{{ result.decisionDate | date:'dd.MM.yyyy' }}</td>
                    <td class="text-nowrap" [attr.data-name]="'norge.soknad.kolonne-bostyrer' | translate">{{ result.trusteeName }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </form>
    }
  </div>
</div>
